import { SnowZoneEnum } from '@e-socna/data-layer';

export const snowZoneLabels = {
  [SnowZoneEnum.A1]: 'A1',
  [SnowZoneEnum.A2]: 'A2',
  [SnowZoneEnum.B1]: 'B1',
  [SnowZoneEnum.B2]: 'B2',
  [SnowZoneEnum.C1]: 'C1',
  [SnowZoneEnum.C2]: 'C2',
  [SnowZoneEnum.D]: 'D',
  [SnowZoneEnum.E]: 'E',
};
